module.exports = __webpack_public_path__ + "media/images/icons/outlined/send-f0db5df98dc21b63ad2d2e5e3010479a.svg";